import { useContext, useRef } from 'react';
import { ExperienceTrackerContext } from './ExperienceTrackerContext';
export function ExperienceStart(_ref) {
  var id = _ref.id,
    name = _ref.name,
    attributes = _ref.attributes,
    collect = _ref.collect,
    onSuccess = _ref.onSuccess;
  var experienceTracker = useContext(ExperienceTrackerContext);
  var wasCalledRef = useRef(false);
  if (!wasCalledRef.current) {
    experienceTracker.start({
      attributes: attributes,
      name: name,
      id: id,
      collect: collect,
      onSuccess: onSuccess
    });
    wasCalledRef.current = true;
  }
  return null;
}